export default {
	data() {
		return {
			date: {
				ranges: {
					Hoy: [this.$moment().startOf('days'), this.$moment()],

					'Este mes': [this.$moment().startOf('months'), this.$moment()],
					'Esta semana': [this.$moment().startOf('weeks'), this.$moment()],
					'Este año': [this.$moment().startOf('years'), this.$moment()],

					'7 días': [this.$moment().subtract(1, 'weeks'), this.$moment()],
					'31 días': [this.$moment().subtract(1, 'months'), this.$moment()],
					'1 año': [this.$moment().subtract(1, 'years'), this.$moment()],
				},
			},
		};
	},
	methods: {
		parser() {
			const self = this;

			return {
				double(value, decimals = 2) {
					if (value !== null && value !== undefined) {
						const float = parseFloat(value.toString().replace(',', '.'));

						if (!isNaN(float) && float >= 0) {
							value = float * 100;
							return (value / 100).toFixed(decimals).toString().replace('.', ',');
						}
					}

					return '';
				},
				doubleView(value) {
					const s = value.toString();

					const lW = s.substr(s.length - 1, 1);
					const plW = s.substr(s.length - 2, 1);

					if (lW === '0' && plW === '0') {
						return s.substr(0, s.length - 2);
					} if (plW !== '0') {
						return `${s.substr(0, s.length - 2)},${plW}`;
					}
					return `${s.substr(0, s.length - 2)},${plW}${lW}`;
				},
				price(value) {
					if (value || value === 0 || value === '0') {
						return parseInt(value.toString().replace(',', ''), 10);
					}
					return null;
				},
				tag(type) {
					const data = {
						text: '',
						color: '',
					};

					switch (type) {
					case 'category':
						data.text = 'Categoría';
						break;
					case 'group':
						data.text = 'Grupo';
						break;
					case 'brand':
						data.text = 'Marca';
						break;
					case 'store':
						data.text = 'Tienda';
						break;
					case 'hashtag':
						data.text = 'Hashtag';
						break;
					default:
						data.text = '';
					}

					switch (type) {
					case 'category':
						data.color = self.$vars.colors.success;
						break;
					case 'group':
						data.color = self.$vars.colors.warning;
						break;
					case 'brand':
						data.color = self.$vars.colors.primary;
						break;
					case 'store':
						data.color = self.$vars.colors.danger;
						break;
					default:
						data.color = self.$vars.colors.secondary;
					}


					return data;
				},
				dealStatus(type) {
					const data = {
						icon: null,
						text: null,
						slug: null,
						color: null,
					};

					switch (type) {
					case 'active':
						data.text = 'Activo';
						data.color = self.$vars.colors.success;
						data.slug = type;
						data.icon = 'eye';
						break;

					case 'expired':
						data.text = 'Agotado';
						data.color = self.$vars.colors.danger;
						data.slug = type;
						data.icon = 'eye-invisible';
						break;

					case 'pending':
						data.text = 'En revision...';
						data.color = self.$vars.colors.primary;
						data.slug = type;
						data.icon = 'alert';
						break;

					case 'draft':
						data.text = 'Borrador';
						data.color = self.$vars.colors.warning;
						data.slug = type;
						data.icon = 'file';
						break;

					case 'disabled':
						data.text = 'Eliminado';
						data.color = self.$vars.colors['gray-5'];
						data.slug = type;
						data.icon = 'delete';
						break;

					default:
					}

					return data;
				},
				popularity(type) {
					const data = {
						text: '',
						color: '',
						icon: '',
					};


					switch (type) {
					case 'top5':
						data.text = 'Top 5';
						break;
					case 'superpopular':
						data.text = 'Superpopular';
						break;
					case 'verypopular':
						data.text = 'Muy popular';
						break;
					case 'popular':
						data.text = 'Popular';
						break;

					default:
						data.text = null;
					}

					switch (type) {
					case 'top5':
						data.color = self.$vars.colors.danger;
						break;
					case 'superpopular':
						data.color = self.$vars.colors.warning;
						break;
					case 'verypopular':
						data.color = self.$vars.colors.success;
						break;
					case 'popular':
						data.color = self.$vars.colors.primary;
						break;
					default:
						data.color = null;
					}

					switch (type) {
					case 'top5':
						data.icon = ['far', 'grin-hearts'];
						break;
					case 'superpopular':
						data.icon = ['far', 'laugh-beam'];
						break;
					case 'verypopular':
						data.icon = ['far', 'grin-wink'];
						break;
					case 'popular':
						data.icon = ['far', 'smile-beam'];
						break;
					default:
						data.icon = null;
					}


					return data;
				},
				commentLevel(deal) {
					if (deal.comments > 50) {
						return 'badge-danger';
					} if (deal.comments > 30) {
						return 'badge-warning';
					} if (deal.comments > 15) {
						return 'badge-success';
					} if (deal.comments > 0) {
						return 'badge-success';
					}
					return 'badge-light';
				},
				urlify(text) {
					const urlRegex = /(https?:\/\/[^\s]+)/g;
					return self.$sanitize(text.replace(urlRegex, url => `<a target="_blank" href="${url}">${url.length > 50 ? `${url.substring(0, 50)}...` : url}</a>`));
				},
			};
		},
	},

};
